
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as accountAN9B3sqnIbMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue?macro=true";
import { default as index9eagspWK7wMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue?macro=true";
import { default as blockchain_45wallet5u9Y9XFmGVMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue?macro=true";
import { default as dedicated_45addressAmR9UgvfxcMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue?macro=true";
import { default as optionsCcXEbMhe3LMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue?macro=true";
import { default as indexZHXToFLBMSMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue?macro=true";
import { default as binanceMHooeVuh7eMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue?macro=true";
import { default as _91network_93qt1iV7imnrMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue?macro=true";
import { default as indexB4qBBrQFAaMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue?macro=true";
import { default as brlaM5hERHnYyVMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue?macro=true";
import { default as coinbase_wallet69KWwdinO2Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue?macro=true";
import { default as coinbasexmlL0EkkjlMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue?macro=true";
import { default as eurvxXDktfgMCMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue?macro=true";
import { default as forex6DHMBAldvAMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue?macro=true";
import { default as gbpzbrin4hZf9Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue?macro=true";
import { default as international_bankZZLR2pz99oMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue?macro=true";
import { default as internationalluJ5ScCS7iMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue?macro=true";
import { default as krakenWqdTkFTGX2Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue?macro=true";
import { default as ngnljiglRrtsSMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue?macro=true";
import { default as usggVsDNWktcMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue?macro=true";
import { default as optionsZ6W3IIiTRMMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue?macro=true";
import { default as rampsPMr7G88BbYMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue?macro=true";
import { default as coinbaseirsIyMc83yMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue?macro=true";
import { default as verify_45walletw3qo9xpVDeMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue?macro=true";
import { default as _91uuid_93tMJXAsJ8y1Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue?macro=true";
import { default as _91token_93X44Ur29WqFMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue?macro=true";
import { default as loginuyYqV0RTA4Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue?macro=true";
import { default as registervQQhe1rIPGMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue?macro=true";
import { default as blockedOZ2wHnArHBMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue?macro=true";
import { default as classificationC6bLzQz55RMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue?macro=true";
import { default as index6Q6xPpzdcLMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue?macro=true";
import { default as indexc17YCbdywdMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue?macro=true";
import { default as dashboardJ5SgAKdJnlMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue?macro=true";
import { default as developerrRu18xmRanMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue?macro=true";
import { default as pay_scheduleFvYHgvXUvxMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue?macro=true";
import { default as indexTjwiz9O02XMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue?macro=true";
import { default as _91accountId_934RaMLQZ9cKMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue?macro=true";
import { default as deposit_45us5VwHYI8FKsMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue?macro=true";
import { default as deposittyvljd8oZwMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue?macro=true";
import { default as _91accountId_93bQUvEc64p7Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue?macro=true";
import { default as riseidi3uLYuUKdeMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue?macro=true";
import { default as fundmdv6zbFvLrMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue?macro=true";
import { default as indexh35RpZpD2BMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue?macro=true";
import { default as _91code_93ADU6W890J7Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue?macro=true";
import { default as _91id_93ZPadwAsMGpMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue?macro=true";
import { default as indexEQp9DUJ4m3Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue?macro=true";
import { default as indexEWSHCDRu3TMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue?macro=true";
import { default as jwtPDAIKOqRA8Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue?macro=true";
import { default as indexZ8YVgq1EMmMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue?macro=true";
import { default as teamzILKBemTCSMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue?macro=true";
import { default as index20nfBYBC1RMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue?macro=true";
import { default as onboardingvUS1PkrgdfMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue?macro=true";
import { default as hourlyM737usAjmUMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/hourly.vue?macro=true";
import { default as instanto51TQ6tPbWMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/instant.vue?macro=true";
import { default as milestoneYO5YV9xxmVMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/milestone.vue?macro=true";
import { default as onceec5m1LuCqRMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/once.vue?macro=true";
import { default as recurringbQ2q43KVSfMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/recurring.vue?macro=true";
import { default as _91userId_93XNBMCOMs9YMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId].vue?macro=true";
import { default as csv5ZhSMbPOMXMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/batch/csv.vue?macro=true";
import { default as index5rGPDT6YpiMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/batch/index.vue?macro=true";
import { default as indexs0pd3Bgea2Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/index.vue?macro=true";
import { default as managementZ3oS4s3kLaMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/management.vue?macro=true";
import { default as _91id_93FcVjrRQPYEMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue?macro=true";
import { default as _91id_93C7bkKvvPa0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue?macro=true";
import { default as _91psId_93WUW02VNnj3Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/timesheets/[psId].vue?macro=true";
import { default as indexzGa698jjwEMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/timesheets/index.vue?macro=true";
import { default as transaction_45historyeQoKsnONzPMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue?macro=true";
import { default as playgroundvRegePY6APMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue?macro=true";
import { default as business09JrU0voZ5Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue?macro=true";
import { default as indexaZu5WdzaYiMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue?macro=true";
import { default as referral2XVMY2ZTHTMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue?macro=true";
import { default as riseid_45erc20_45withdrawK1t9KjYJTvMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue?macro=true";
import { default as riseidDoH1vLo4hZMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue?macro=true";
import { default as security9YfawOMJBvMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue?macro=true";
import { default as sign_45document7s6QUNZntHMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue?macro=true";
import { default as _2faQHmbblMk4xMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue?macro=true";
import { default as callbackqutbU0YmNoMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue?macro=true";
import { default as codeNvUW95foIWMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue?macro=true";
import { default as indexq8YLgTVcuOMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue?macro=true";
import { default as sign_45outQ5VdsGcgx2Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue?macro=true";
import { default as codew78xGKlZKkMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue?macro=true";
import { default as indexl9eZ7MvtyHMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue?macro=true";
import { default as waitingUDOCLvt6omMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue?macro=true";
import { default as indexQ6vbLUfGwVMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue?macro=true";
import { default as optionsNGh1vTsATpMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue?macro=true";
import { default as indexUnAY3dIYWdMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue?macro=true";
import { default as import3qHRm7pSHdMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue?macro=true";
import { default as index5xwHm1st2HMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue?macro=true";
import { default as batch_warmed_lightuMnw4TPyb2Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue?macro=true";
import { default as batch_warmed4Dv9cueTgPMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue?macro=true";
import { default as directFKDr5yIqs0Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue?macro=true";
import { default as sumsubjEpHMJnCt1Meta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue?macro=true";
import { default as warmed_lightoSQ7eSwhqPMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue?macro=true";
import { default as warmedg54NaABQFwMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue?macro=true";
import { default as invitectMxwsI1KoMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue?macro=true";
import { default as indexwmhtOqf0CdMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue?macro=true";
import { default as _91accountId_93zXCUisKpKpMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue?macro=true";
import { default as _91accountId_93cru3juqQtuMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue?macro=true";
import { default as withdrawW3o0GKi4WbMeta } from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: accountAN9B3sqnIbMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/account.vue")
  },
  {
    name: "accounts-add-funding",
    path: "/accounts/add-funding",
    meta: index9eagspWK7wMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/index.vue")
  },
  {
    name: "accounts-add-funding-options",
    path: "/accounts/add-funding/options",
    meta: optionsCcXEbMhe3LMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options.vue"),
    children: [
  {
    name: "accounts-add-funding-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/blockchain-wallet.vue")
  },
  {
    name: "accounts-add-funding-options-dedicated-address",
    path: "dedicated-address",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-funding/options/dedicated-address.vue")
  }
]
  },
  {
    name: "accounts-add-withdraw",
    path: "/accounts/add-withdraw",
    meta: indexZHXToFLBMSMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/index.vue")
  },
  {
    name: "accounts-add-withdraw-options",
    path: "/accounts/add-withdraw/options",
    meta: optionsZ6W3IIiTRMMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options.vue"),
    children: [
  {
    name: "accounts-add-withdraw-options-binance",
    path: "binance",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/binance.vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet-network",
    path: "blockchain-wallet/:network()",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/[network].vue")
  },
  {
    name: "accounts-add-withdraw-options-blockchain-wallet",
    path: "blockchain-wallet",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/blockchain-wallet/index.vue")
  },
  {
    name: "accounts-add-withdraw-options-brla",
    path: "brla",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/brla.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase_wallet",
    path: "coinbase_wallet",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase_wallet.vue")
  },
  {
    name: "accounts-add-withdraw-options-coinbase",
    path: "coinbase",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/coinbase.vue")
  },
  {
    name: "accounts-add-withdraw-options-eur",
    path: "eur",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/eur.vue")
  },
  {
    name: "accounts-add-withdraw-options-forex",
    path: "forex",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/forex.vue")
  },
  {
    name: "accounts-add-withdraw-options-gbp",
    path: "gbp",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/gbp.vue")
  },
  {
    name: "accounts-add-withdraw-options-international_bank",
    path: "international_bank",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international_bank.vue")
  },
  {
    name: "accounts-add-withdraw-options-international",
    path: "international",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/international.vue")
  },
  {
    name: "accounts-add-withdraw-options-kraken",
    path: "kraken",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/kraken.vue")
  },
  {
    name: "accounts-add-withdraw-options-ngn",
    path: "ngn",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/ngn.vue")
  },
  {
    name: "accounts-add-withdraw-options-us",
    path: "us",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/options/us.vue")
  }
]
  },
  {
    name: "accounts-add-withdraw-ramps",
    path: "/accounts/add-withdraw/ramps",
    meta: rampsPMr7G88BbYMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add-withdraw/ramps.vue")
  },
  {
    name: "accounts-add-callback-coinbase",
    path: "/accounts/add/callback/coinbase",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/coinbase.vue")
  },
  {
    name: "accounts-add-callback-verify-wallet",
    path: "/accounts/add/callback/verify-wallet",
    meta: verify_45walletw3qo9xpVDeMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/accounts/add/callback/verify-wallet.vue")
  },
  {
    name: "auth-invite-uuid",
    path: "/auth/invite/:uuid()",
    meta: _91uuid_93tMJXAsJ8y1Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/[uuid].vue")
  },
  {
    name: "auth-invite-b2b-token",
    path: "/auth/invite/b2b/:token()",
    meta: _91token_93X44Ur29WqFMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/invite/b2b/[token].vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/login.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/auth/register.vue")
  },
  {
    name: "blocked",
    path: "/blocked",
    meta: blockedOZ2wHnArHBMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/blocked.vue")
  },
  {
    name: "clients-id-classification",
    path: "/clients/:id()/classification",
    meta: classificationC6bLzQz55RMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/classification.vue")
  },
  {
    name: "clients-id",
    path: "/clients/:id()",
    meta: index6Q6xPpzdcLMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/[id]/index.vue")
  },
  {
    name: "clients",
    path: "/clients",
    meta: indexc17YCbdywdMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/clients/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardJ5SgAKdJnlMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/dashboard.vue")
  },
  {
    name: "developer",
    path: "/developer",
    meta: developerrRu18xmRanMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/developer.vue")
  },
  {
    name: "documents-payschedule-pay_schedule",
    path: "/documents/:payschedule()/pay_schedule",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/[payschedule]/pay_schedule.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: indexTjwiz9O02XMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/documents/index.vue")
  },
  {
    name: "fund",
    path: "/fund",
    meta: fundmdv6zbFvLrMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund.vue"),
    children: [
  {
    name: "fund-dedicated-address-accountId",
    path: "dedicated-address/:accountId()",
    meta: _91accountId_934RaMLQZ9cKMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/dedicated-address/[accountId].vue")
  },
  {
    name: "fund-deposit-us",
    path: "deposit-us",
    meta: deposit_45us5VwHYI8FKsMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit-us.vue")
  },
  {
    name: "fund-deposit",
    path: "deposit",
    meta: deposittyvljd8oZwMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/deposit.vue")
  },
  {
    name: "fund-external-account-accountId",
    path: "external-account/:accountId()",
    meta: _91accountId_93bQUvEc64p7Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/external-account/[accountId].vue")
  },
  {
    name: "fund-riseid",
    path: "riseid",
    meta: riseidi3uLYuUKdeMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/fund/riseid.vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexh35RpZpD2BMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/index.vue")
  },
  {
    name: "invite-code",
    path: "/invite/:code()",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invite/[code].vue")
  },
  {
    name: "invoices-add-id",
    path: "/invoices/add/:id()",
    meta: _91id_93ZPadwAsMGpMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/[id].vue")
  },
  {
    name: "invoices-add",
    path: "/invoices/add",
    meta: indexEQp9DUJ4m3Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/add/index.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexEWSHCDRu3TMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/invoices/index.vue")
  },
  {
    name: "jwt",
    path: "/jwt",
    meta: jwtPDAIKOqRA8Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/jwt.vue")
  },
  {
    name: "management-company-create",
    path: "/management/company/create",
    meta: indexZ8YVgq1EMmMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/index.vue")
  },
  {
    name: "management-company-create-team",
    path: "/management/company/create/team",
    meta: teamzILKBemTCSMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/create/team.vue")
  },
  {
    name: "management-company",
    path: "/management/company",
    meta: index20nfBYBC1RMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/management/company/index.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboardingvUS1PkrgdfMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/onboarding.vue")
  },
  {
    name: "payments-userId",
    path: "/payments/:userId()",
    meta: _91userId_93XNBMCOMs9YMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId].vue"),
    children: [
  {
    name: "payments-userId-hourly",
    path: "hourly",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/hourly.vue")
  },
  {
    name: "payments-userId-instant",
    path: "instant",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/instant.vue")
  },
  {
    name: "payments-userId-milestone",
    path: "milestone",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/milestone.vue")
  },
  {
    name: "payments-userId-once",
    path: "once",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/once.vue")
  },
  {
    name: "payments-userId-recurring",
    path: "recurring",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/[userId]/recurring.vue")
  }
]
  },
  {
    name: "payments-batch-csv",
    path: "/payments/batch/csv",
    meta: csv5ZhSMbPOMXMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/batch/csv.vue")
  },
  {
    name: "payments-batch",
    path: "/payments/batch",
    meta: index5rGPDT6YpiMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/batch/index.vue")
  },
  {
    name: "payments",
    path: "/payments",
    meta: indexs0pd3Bgea2Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/index.vue")
  },
  {
    name: "payments-management",
    path: "/payments/management",
    meta: managementZ3oS4s3kLaMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/management.vue")
  },
  {
    name: "payments-receipts-fund-id",
    path: "/payments/receipts/fund/:id()",
    meta: _91id_93FcVjrRQPYEMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/fund/[id].vue")
  },
  {
    name: "payments-receipts-payment-id",
    path: "/payments/receipts/payment/:id()",
    meta: _91id_93C7bkKvvPa0Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/receipts/payment/[id].vue")
  },
  {
    name: "payments-timesheets-psId",
    path: "/payments/timesheets/:psId()",
    meta: _91psId_93WUW02VNnj3Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/timesheets/[psId].vue")
  },
  {
    name: "payments-timesheets",
    path: "/payments/timesheets",
    meta: indexzGa698jjwEMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/timesheets/index.vue")
  },
  {
    name: "payments-transaction-history",
    path: "/payments/transaction-history",
    meta: transaction_45historyeQoKsnONzPMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/payments/transaction-history.vue")
  },
  {
    name: "playground",
    path: "/playground",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/playground.vue")
  },
  {
    name: "profile-business",
    path: "/profile/business",
    meta: business09JrU0voZ5Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/business.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexaZu5WdzaYiMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/profile/index.vue")
  },
  {
    name: "referral",
    path: "/referral",
    meta: referral2XVMY2ZTHTMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/referral.vue")
  },
  {
    name: "riseid-erc20-withdraw",
    path: "/riseid-erc20-withdraw",
    meta: riseid_45erc20_45withdrawK1t9KjYJTvMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid-erc20-withdraw.vue")
  },
  {
    name: "riseid",
    path: "/riseid",
    meta: riseidDoH1vLo4hZMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/riseid.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: security9YfawOMJBvMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/security.vue")
  },
  {
    name: "sign-document",
    path: "/sign-document",
    meta: sign_45document7s6QUNZntHMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-document.vue")
  },
  {
    name: "sign-in-2fa",
    path: "/sign-in/2fa",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/2fa.vue")
  },
  {
    name: "sign-in-callback",
    path: "/sign-in/callback",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/callback.vue")
  },
  {
    name: "sign-in-code",
    path: "/sign-in/code",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/code.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-in/index.vue")
  },
  {
    name: "sign-out",
    path: "/sign-out",
    meta: sign_45outQ5VdsGcgx2Meta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-out.vue")
  },
  {
    name: "sign-up-code",
    path: "/sign-up/code",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/code.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/index.vue")
  },
  {
    name: "sign-up-waiting",
    path: "/sign-up/waiting",
    meta: waitingUDOCLvt6omMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/sign-up/waiting.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: indexQ6vbLUfGwVMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/index.vue")
  },
  {
    name: "subscription-options",
    path: "/subscription/options",
    meta: optionsNGh1vTsATpMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/subscription/options.vue")
  },
  {
    name: "talent-id",
    path: "/talent/:id()",
    meta: indexUnAY3dIYWdMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/[id]/index.vue")
  },
  {
    name: "talent-import",
    path: "/talent/import",
    meta: import3qHRm7pSHdMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/import.vue")
  },
  {
    name: "talent",
    path: "/talent",
    meta: index5xwHm1st2HMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/index.vue")
  },
  {
    name: "talent-invite",
    path: "/talent/invite",
    meta: invitectMxwsI1KoMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite.vue"),
    children: [
  {
    name: "talent-invite-batch_warmed_light",
    path: "batch_warmed_light",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed_light.vue")
  },
  {
    name: "talent-invite-batch_warmed",
    path: "batch_warmed",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/batch_warmed.vue")
  },
  {
    name: "talent-invite-direct",
    path: "direct",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/direct.vue")
  },
  {
    name: "talent-invite-sumsub",
    path: "sumsub",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/sumsub.vue")
  },
  {
    name: "talent-invite-warmed_light",
    path: "warmed_light",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed_light.vue")
  },
  {
    name: "talent-invite-warmed",
    path: "warmed",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/talent/invite/warmed.vue")
  }
]
  },
  {
    name: "tasks",
    path: "/tasks",
    meta: indexwmhtOqf0CdMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/tasks/index.vue")
  },
  {
    name: "withdraw",
    path: "/withdraw",
    meta: withdrawW3o0GKi4WbMeta || {},
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw.vue"),
    children: [
  {
    name: "withdraw-blockchain-accountId",
    path: "blockchain/:accountId()",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/blockchain/[accountId].vue")
  },
  {
    name: "withdraw-wire-accountId",
    path: "wire/:accountId()",
    component: () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/pages/withdraw/wire/[accountId].vue")
  }
]
  }
]